module.exports = __webpack_public_path__ + "img/openleft.35e7cf8b.png";